
const MIN_COUNTRY_JOBS_BEFORE_SHOW_ADMIN_AREA_FILTERS = 10

const showAdminAreaFiltersUnderCountry = (countryJobCount) => {
    return countryJobCount >= MIN_COUNTRY_JOBS_BEFORE_SHOW_ADMIN_AREA_FILTERS
}

export default {
    showAdminAreaFiltersUnderCountry
}
